import { createStore } from 'vuex'

interface FlashMessage {
  id: string
  type: string
  message: string
}

export default createStore({
  state: {
    flashMessages: [] as FlashMessage[]
  },
  mutations: {
    addFlashMessage (state, { id, type, message }) {
      state.flashMessages.push({
        id: id,
        type: type,
        message: message
      })
    },
    deleteFlashMessage (state, id) {
      const messageIndex = state.flashMessages.findIndex((message) => message.id === id)
      state.flashMessages.splice(messageIndex, 1)
    }
  },
  actions: {
    addFlashMessage: ({ commit }, { type, message }) => {
      const timestamp = new Date().getTime()
      const unique_id = timestamp.toString(16)

      const flashMessage = {
        id: unique_id,
        type: type,
        message: message
      }

      commit('addFlashMessage', flashMessage)

      setTimeout(() => {
        commit('deleteFlashMessage', unique_id)
      }, 3000)
    }
  },
  modules: {
  }
})